import Hero from '../components/business/Hero';
import DiscoveryToPayment from '../components/business/DiscoveryToPayment';
import ProblemComparison from '../components/business/ProblemComparison';
import DayInLife from '../components/business/DayInLife';
import SolutionOverview from '../components/business/SolutionOverview';
import AdminFeatures from '../components/business/AdminFeatures';
import Pricing from '../components/business/Pricing';
import Partners from '../components/business/Partners';
import ExpertConnect from '../components/business/ExpertConnect';
import Benefits from '../components/business/Benefits';
import FutureFeatures from '../components/business/FutureFeatures';
import ClosingMessage from '../components/business/ClosingMessage';
import Footer from '../components/business/Footer';
import ScrollToTop from '../components/ScrollToTop';

export default function BusinessLanding() {
  return (
    <div className="app">
      {/* 1. Hero - 스포츠 예약, 이제 쇼핑처럼 쉽게 */}
      <Hero />

      {/* 2-4. Problem1 + Solution1 - 예약 허들 문제 및 간편 예약 해결책 */}
      <DiscoveryToPayment />

      {/* 5. Problem2 - 수동 고객 관리의 어려움 (연락해야 할 고객 놓침) */}
      <DayInLife />

      {/* 6-7. Solution2 - 쇼핑몰처럼 자동화된 고객 관리 */}
      <ProblemComparison />

      {/* 7. 올림이 대신하는 세 가지 */}
      <SolutionOverview />

      {/* 8. 기능 상세 - 가로 탭 6개 (핵심) */}
      <AdminFeatures />

      {/* 9. 요금제 */}
      <Pricing />

      {/* 10. 협력사 Placeholder */}
      <Partners />

      {/* 11. 전문가 연결 */}
      <ExpertConnect />

      {/* 12. 파트너 혜택 */}
      <Benefits />

      {/* 13. 앞으로 제공할 기능 */}
      <FutureFeatures />

      {/* 14. 마무리 메시지 */}
      <ClosingMessage />

      {/* 15. Footer */}
      <Footer />

      <ScrollToTop />
    </div>
  );
}
